import React, { useEffect, useState, useContext, useCallback } from 'react';
import { RouteComponentProps } from '@reach/router';
import {
    LayoutStandardCrud,
    BlockLoading2,
    FiltersDisplay,
    AntButton,
} from '@/components';
import { Icon, Tooltip, message } from 'antd';
import _ from 'lodash';
import { StoreContext } from '@/stores';
import { useNet, delay, useBeforeFirstDataLoaded } from '@/utils';
import { observer } from 'mobx-react-lite';
import DemoTable from './components/table';
import { ActionDelete } from './components/delete';
import { ActionMDelete } from './components/m-delete';
import { runInAction } from 'mobx';
import { DTitle2 } from '@/components/common/dtitle2';
import {
    defaultAuthDeco,
    dFilterHOC,
    useDefaultDFilterSnippets,
} from '@/containers/hoc';
import './index.scss';
import { MOpResultDisplayContainer } from '@/components';
import FormDrawerCreate from './components/form-drawer-create';
import FormDrawerDetail from './components/form-drawer-detail';
import classname from 'classname';
import { DTitle } from '../../custom/list/components/dtitle';
import { useFirstLv4Menu } from '@/stores/utils/fast-filters';
import { ActionExport } from '../../activation-record/list/components/export';

const DemoList: React.FC<RouteComponentProps & {
    type: string;
    dfilters?: any;
}> = ({ type = 'category', dfilters }) => {
    
    const store = useContext(StoreContext);
    const [defaultStore] = useState(() => new store.ProcessCatStore());
    console.log(defaultStore, 'defaultStore');
    
    const userStore = store.getAuthStore();

    const ack = dtext('crm')('process-category-message-' + type, '');

    const {
        tableCode, // 动态列表
        defaultPagination,
        defaultSorter,
        defaultMeta,
        pageTitle,
        defaultPerm,
        defaultFilter,
        defaultMSelect,
        defaultFastFilters,
        condListbyFilterData,
    } = defaultStore;
    console.log('defaultFastFilters', defaultFastFilters)

    const { confirmedfilterData } = defaultFilter;

    const { paginationForFetch } = defaultPagination;

    const { sortersForFetch } = defaultSorter;

    const [fastFilterReady, setFastFilterReady] = useState(false);
    const [preRequiredReady, setPreRequiredReady] = useState(false);

    useEffect(() => {
        console.log('type', type);
        runInAction(() => {
            defaultFastFilters.setType(type);
            defaultStore.setListType(type);
        });
    }, [type]);

    const { selectedLv4MenuFilters, lv4MenuFilters } = defaultFastFilters;

    // 设置四级菜单
    useEffect(() => {
        console.log('dfilters', dfilters);
        defaultFastFilters.setFilters(dfilters);
    }, []);

    // 自动选择第一个四级菜单
    useFirstLv4Menu(defaultFastFilters, () => {
        setFastFilterReady(true);
    });

    // 根据四级菜单的选择，动态更改store的元信息，权限
    const selectedTableCode = selectedLv4MenuFilters[0]?.key;
    useEffect(() => {
        if (selectedTableCode === undefined) {
            return;
        }
        // 当tableCode更新，意味着内部各种东西已经更新
        defaultStore.setTableCode(selectedTableCode);
    }, [selectedTableCode]);

    // 更新刷新方法
    const listFetch = useCallback(() => defaultStore.fetch(), [tableCode]);
    const [error, loading, reload] = useNet(listFetch, {
        autoLoad: false,
        refreshKeys: [tableCode || '', 'raw-process'],
    });

    // 翻页
    useEffect(() => {
        // 元信息，准备用户可查询的
        // 再一次ready，再查询
        if (!preRequiredReady) {
            return;
        }
        reload();
    }, [
        paginationForFetch,
        sortersForFetch,
        condListbyFilterData,
        preRequiredReady,
    ]);

    useEffect(() => {
        if (!userStore.userInfo) {
            return;
        }
        defaultStore.setSysUser(userStore.userInfo.sysUser);
    }, [userStore.userInfo]);

    // 初始化新的meta和perm和filter
    useEffect(() => {
        if (
            userStore.userInfo &&
            tableCode !== null &&
            defaultMeta !== null &&
            defaultPerm !== null
        ) {
            defaultMeta.setTableId(tableCode);
            defaultMeta.setOpUsername(
                userStore.userInfo.userId + '-' + tableCode,
            );
            defaultStore.setSysUser(userStore.userInfo.sysUser);

            Promise.all([defaultMeta.fetch(), defaultPerm.fetch()])
                .then(async () => {
                    setPreRequiredReady(true);
                    defaultFilter.resetFilterData();
                    defaultFilter.confirmFilterData();
                })
                .catch(() => {});
        }
    }, [userStore.userInfo, tableCode]);

    // 快捷筛选
    const dtitleProps: any = {
        title:
            defaultFastFilters.selectedLv4MenuFilters.length === 0
                ? pageTitle
                : defaultFastFilters.selectedLv4MenuFilters[0].label,
    };
    console.log('pageTitle', pageTitle);

    dtitleProps.list = defaultFastFilters.lv4MenuFilters;
    dtitleProps.selected = selectedLv4MenuFilters;
    dtitleProps.onListItemClick = (item: any) => {
        // 在菜单切换的时候，需要开始做各种重新准备工作
        if (item.key === selectedLv4MenuFilters[0]?.key) {
            return;
        }
        setPreRequiredReady(false);
        defaultFastFilters.setSelectedLv4MenuFilters([item]);
    };
    console.log('dtitleProps', dtitleProps);
    const title = <DTitle2 {...dtitleProps} />;

    const [isBeforeFirstLoaded] = useBeforeFirstDataLoaded(defaultStore);

    const noReady =
        !preRequiredReady || !fastFilterReady || !defaultMeta || !defaultPerm;

    const filtersDisplay = defaultMeta ? (
        <FiltersDisplay
            objectMeta={defaultMeta.objectMeta}
            filterData={confirmedfilterData}
            sorterData={defaultStore.defaultSorter}
            onClose={(key: string) => {
                defaultFilter.onFilterClear(key);
            }}
        />
    ) : null;

    const popups = (
        <>
            <ActionExport defaultStore={defaultStore} />
            <MOpResultDisplayContainer defaultStore={defaultStore} />
            <ActionDelete defaultStore={defaultStore} />
            <ActionMDelete defaultStore={defaultStore} />
            <FormDrawerCreate
                key={defaultStore.detailTableCode || 'None'}
                defaultStore={defaultStore}
                preRequiredReady={!noReady}
            />
            <FormDrawerDetail
                key={defaultStore.detailTableCode || 'None'}
                defaultStore={defaultStore}
                preRequiredReady={!noReady}
            />
        </>
    );

    const globalOps = (
        <>
            {defaultPerm !== null &&
                defaultPerm.getPermByTypeAndAction(type)('create').visible &&
                null}
            <AntButton
                onClick={() => {
                    runInAction(() => {
                        defaultStore.setAction('create');
                        defaultStore.startNewData();
                    });
                }}
                type="primary"
                size="large"
            >
                新建流程
            </AntButton>
            <AntButton
                onClick={() => {
                    defaultStore.setAction('export');
                }}
                size="large"
            >
                导出
            </AntButton>
        </>
    );
    const multipleOps = (
        <div
            className={classname({
                'mselected-ops': true,
                'multiple-mode': defaultMSelect.isMSelectionMode,
                'normal-mode': !defaultMSelect.isMSelectionMode,
            })}
        >
            <Tooltip title="取消多选">
                <span
                    onClick={() => {
                        defaultMSelect.setMSelectedData([]);
                    }}
                    style={{
                        padding: 5,
                        cursor: 'pointer',
                    }}
                >
                    <Icon type="close" />
                </span>
            </Tooltip>
            <div>
                <span>已选{defaultMSelect.mSeletedData.length}条：</span>
            </div>
            {defaultPerm !== null &&
                defaultPerm.getPermByTypeAndAction(type)('delete').visible && (
                    <AntButton
                        onClick={() => {
                            defaultStore.setAction('m-delete');
                        }}
                        size="large"
                    >
                        删除
                    </AntButton>
                )}
        </div>
    );

    const dataTable = (
        <div style={{ display: 'flex', height: '100%' }}>
            {title}
            {isBeforeFirstLoaded || noReady ? (
                <div
                    style={{
                        flexGrow: 1,
                        paddingBottom: 40,
                    }}
                >
                    <div
                        style={{
                            background: 'white',
                            height: '100%',
                        }}
                    >
                        <BlockLoading2 />
                    </div>
                </div>
            ) : (
                <DemoTable
                    tableCode={selectedTableCode}
                    key={'table-' + selectedTableCode}
                    defaultStore={defaultStore}
                    loading={loading}
                />
            )}
        </div>
    );

    const layoutComs = {
        popups,
        title: '流程分类',
        globalOps,
        filters: null,
        multipleOps,
        dataTable,
        message: null, // ack ? <Alert closable message={ack} /> : null,
        filtersDisplay,
    };

    return <LayoutStandardCrud className="page-process-list" {...layoutComs} />;
};

const FinalDemoList = dFilterHOC(observer(DemoList), 'process');
export default FinalDemoList;
